<template>
  <div
    class="notification is-light my-0 p-5"
    :class="
      gameStats.conflicted > 0
        ? 'is-danger'
        : gameStats.finished === gameStats.matches
        ? 'is-success'
        : 'is-warning'
    "
  >
    <span class="tag is-success is-large mr-2">
      Live: {{ gameStats.live }}
    </span>

    <span class="tag is-primary is-large mr-2">
      Bye: {{ gameStats.bye }}
    </span>

    <span class="tag is-dark is-large">
      Matches: {{ gameStats.matches }}
    </span>
    =
    <span class="tag is-success is-large">
      Unfinished: {{ gameStats.unfinished }}
    </span>
    +
    <span class="tag is-info is-large">
      Finished: {{ gameStats.finished }}
    </span>
    +
    <span class="tag is-warning is-large">
      Aborted: {{ gameStats.aborted }}
    </span>
    +
    <span class="tag is-danger is-large">
      Conflicted: {{ gameStats.conflicted }}
    </span>

    <p class="has-text-black mt-3">
      <b>Status:</b>

      <span class="has-text-danger">*LIVE*</span>
      = no move yet,
      <span class="has-text-danger">[red text]</span>
      = result mismatch,
      <span class="has-background-warning">[yellow background]</span>
      = player mismatch,
      <span class="has-text-info">[blue]</span>
      = good
    </p>
  </div>
</template>

<script>
export default {
  name: "TournamentGameStats",

  props: {
    gameStats: {
      type: Object,
      required: true,
      validator(value) {
        return (
          typeof value.live === "number" &&
          typeof value.bye === "number" &&
          typeof value.matches === "number" &&
          typeof value.unfinished === "number" &&
          typeof value.finished === "number" &&
          typeof value.aborted === "number" &&
          typeof value.conflicted === "number"
        );
      },
    },
  },
};
</script>

<style scoped>
.notification {
  padding: 0.5rem 0.5rem;
}
</style>
